import { Action } from '@ngrx/store';
import { SendProposalConditionData } from '../models/send-proposal-condition-data.interface';
import { Condition } from '@codegen';

export enum ConditionsTypes {
  GetProposalConditions = '[Conditions] Get proposal conditions',
  SetProposalConditions = '[Conditions] Set proposal conditions',
  SelectProposalCondition = '[Conditions] Select proposal condition',
  SendProposalCondition = '[Conditions] Send proposal condition',
  SetDefaultCondition = '[Conditions] Set default condition',
  SendEvent = '[Conditions] Send event',
}

export class GetProposalConditions implements Action {
  public readonly type = ConditionsTypes.GetProposalConditions;

  constructor(public payload: string) {}
}

export class SetProposalConditions implements Action {
  public readonly type = ConditionsTypes.SetProposalConditions;

  constructor(public payload: Array<Condition>) {}
}

export class SelectProposalCondition implements Action {
  public readonly type = ConditionsTypes.SelectProposalCondition;

  constructor(public payload: string) {}
}

export class SendProposalCondition implements Action {
  public readonly type = ConditionsTypes.SendProposalCondition;

  constructor(public payload: SendProposalConditionData) {}
}

export class SetDefaultCondition implements Action {
  public readonly type = ConditionsTypes.SetDefaultCondition;

  constructor(public readonly: Condition | null) {}
}

export class SendEvent implements Action {
  public readonly type = ConditionsTypes.SendEvent;

  constructor(public payload: string) {}
}

export type ConditionsAction =
  | GetProposalConditions
  | SetProposalConditions
  | SelectProposalCondition
  | SetDefaultCondition
  | SendProposalCondition
  | SendEvent;
